import {
  Stethoscope, Scale, Briefcase, CalendarClock,
  Clock, UserCheck, ShieldCheck, MessageSquare, Lock, MapPin, CalendarRange, BadgeDollarSign,
  Building2, HeartPulse, FlaskConical, Pill, Smile, LineChart, Umbrella, Calculator, Building, Store,
  Cross, BadgeCheck, ShieldPlus, PackageCheck, FileLock2,
} from "lucide-react";

export const PHONE_DISPLAY = "(678) 962-7200";
export const PHONE_TEL = "+16789627200";
export const EMAIL = "info@wilsoncouriersolutions.com";

export const IMAGES = {
  hero: "/brand/hero.jpg",
  specimen: "https://static.prod-images.emergentagent.com/jobs/b4e8e8b1-2e9f-4f1f-bd27-c5925e39ffad/images/8c24af18d337d09f884dc31a70a63a531a123d29d03e2bbf4c19e6c9e5f18b64.png",
  courierPackages: "https://images.pexels.com/photos/6995141/pexels-photo-6995141.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const TRUST_BADGES = [
  { icon: Clock, label: "Same-Day Delivery" },
  { icon: BadgeCheck, label: "HIPAA Trained" },
  { icon: ShieldPlus, label: "Bloodborne Pathogen Certified" },
  { icon: PackageCheck, label: "Secure Medical Transport" },
  { icon: UserCheck, label: "Professional Drivers" },
  { icon: MapPin, label: "Serving Metro Atlanta" },
];

export const SERVICES = [
  {
    icon: Stethoscope,
    title: "Medical Courier",
    tagline: "HIPAA-conscious handling",
    items: ["Specimen transport", "Lab deliveries", "Medical supplies", "Pharmaceutical deliveries", "Hospital-to-clinic transport"],
  },
  {
    icon: Scale,
    title: "Legal Courier",
    tagline: "Time-sensitive filings",
    items: ["Court filings", "Legal documents", "Time-sensitive deliveries", "Law offices"],
  },
  {
    icon: Briefcase,
    title: "Business Courier",
    tagline: "Same-day delivery",
    items: ["Office deliveries", "Interoffice mail", "Contracts", "Financial documents", "Same-day delivery"],
  },
  {
    icon: CalendarClock,
    title: "Scheduled Routes",
    tagline: "Customized logistics",
    items: ["Daily deliveries", "Weekly routes", "Recurring pickups", "Customized business logistics"],
  },
];

export const BENEFITS = [
  { icon: Clock, label: "Same-Day Delivery" },
  { icon: CalendarRange, label: "Scheduled Daily Routes" },
  { icon: PackageCheck, label: "Secure Medical Transport" },
  { icon: UserCheck, label: "Professional Drivers" },
  { icon: FileLock2, label: "Confidential Document Handling" },
  { icon: BadgeCheck, label: "HIPAA Trained" },
  { icon: ShieldPlus, label: "Bloodborne Pathogen Certified" },
  { icon: MessageSquare, label: "Real-Time Communication" },
  { icon: BadgeDollarSign, label: "Competitive Pricing" },
  { icon: MapPin, label: "Locally Owned & Operated" },
];

export const INDUSTRIES = [
  { icon: Building2, label: "Hospitals" },
  { icon: HeartPulse, label: "Medical Offices" },
  { icon: FlaskConical, label: "Laboratories" },
  { icon: Pill, label: "Pharmacies" },
  { icon: Smile, label: "Dental Offices" },
  { icon: Cross, label: "Surgery Centers" },
  { icon: Scale, label: "Law Firms" },
  { icon: LineChart, label: "Financial Advisors" },
  { icon: Umbrella, label: "Insurance Agencies" },
  { icon: Calculator, label: "Accounting Firms" },
  { icon: Building, label: "Corporate Offices" },
  { icon: Store, label: "Small Businesses" },
];

export const PROCESS = [
  { step: "01", title: "Request a Quote", desc: "Tell us what you need moved and when. We respond fast with clear pricing." },
  { step: "02", title: "Schedule Pickup", desc: "Pick a one-time delivery or set up recurring routes that fit your workflow." },
  { step: "03", title: "Secure Transportation", desc: "Trained, professional drivers transport your items securely and on time." },
  { step: "04", title: "Confirmed Delivery", desc: "You get real-time communication and delivery confirmation, every time." },
];

export const TESTIMONIALS = [
  { quote: "Outstanding service. Always on time and professional.", author: "Medical Office Manager", location: "Decatur, GA" },
  { quote: "Wilson Courier Solutions has become our trusted courier partner.", author: "Clinical Lab Director", location: "Atlanta, GA" },
  { quote: "Reliable, responsive, and easy to work with.", author: "Law Firm Administrator", location: "Metro Atlanta" },
];

export const SERVICE_OPTIONS = [
  "Medical Courier", "Legal Courier", "Business Courier", "Scheduled Routes", "Other",
];
